import { render, staticRenderFns } from "./clearfix.vue?vue&type=template&id=845a03e0&"
import script from "./clearfix.vue?vue&type=script&lang=js&"
export * from "./clearfix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports